import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzTypographyModule } from 'ng-zorro-antd/typography';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { ProgramAccountStatusChipModule } from '@libs/src/program-account-status-chip/program-account-status-chip.module';

import { ProgramUserCardComponent } from './program-user-card.component';

@NgModule({
  declarations: [ProgramUserCardComponent],
  exports: [ProgramUserCardComponent],
  imports: [
    AvatarModule,
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    NzTypographyModule,
    MatIconModule,
    ProgramAccountStatusChipModule,
    RouterModule,
  ],
})
export class ProgramUserCardModule {}
